<template lang="pug">
  portal.my-5.mx-auto.px-3.d-flex( to="contols" :disabled="isMobile || isTablet" style="max-width: 1200px;")
    v-btn.mr-4.ml-auto(color="error" text @click="onDelete" :loading="deleteLoading" v-if="hasDelete")
      v-icon(left) mdi-delete
      |Удалить
    v-btn(color="primary" depressed @click="onSave" :loading="saveLoading")
      v-icon(left) mdi-content-save
      span Сохранить
</template>

<script>
import checkDevice from '../../../mixins/checkDevice'

export default {
  mixins: [checkDevice],
  props: {
    deleteLoading: {
      type: Boolean,
      default: false
    },
    saveLoading: {
      type: Boolean,
      default: false
    },
    /**
     * If specifiend, 'delete' button is shown
     */
    hasDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onDelete() {
      this.$emit('delete')
    },
    onSave() {
      this.$emit('save')
    }
  }
}
</script>
